import TicketCard from './ticket-card-view';

export default TicketCard;
